/**
 * @param {HTMLElement} container
 */
export function renderSettings(container) {
  const settingsEl = document.createElement('div');
  settingsEl.className = 'settings-container';

  const keys = loadKeys();

  settingsEl.innerHTML = `
    <div class="settings-card">
      <h2>API Keys (BYOK)</h2>
      <p class="settings-desc">
        This harness operates on a Bring Your Own Key model.
        Your keys are stored locally in your browser and are only sent to the AI provider APIs via this harness.
        The server never stores or logs your keys.
      </p>

      <div class="provider-setting">
        <label>Anthropic (Claude)</label>
        <input type="password" id="key-anthropic" placeholder="sk-ant-..." value="${escapeHtml(keys.anthropic_key || '')}" />
        <small>Used when you select Claude as your LLM.</small>
      </div>

      <div class="provider-setting">
        <label>OpenAI (GPT-4o)</label>
        <input type="password" id="key-openai" placeholder="sk-..." value="${escapeHtml(keys.openai_key || '')}" />
        <small>Used when you select GPT-4o as your LLM.</small>
      </div>

      <div class="provider-setting">
        <label>Moonshot (Kimi K2.6)</label>
        <input type="password" id="key-kimi" placeholder="sk-..." value="${escapeHtml(keys.kimi_key || '')}" />
        <small>Used when you select Kimi as your LLM.</small>
      </div>

      <div class="provider-setting">
        <label>GitHub Token</label>
        <input type="password" id="key-github" placeholder="ghp_..." value="${escapeHtml(keys.github_token || '')}" />
        <small>Required for tool use (read/write files, create PRs, search code).</small>
      </div>

      <div class="provider-setting">
        <label>Default Provider</label>
        <select id="default-provider">
          <option value="anthropic" ${keys.default_provider === 'anthropic' ? 'selected' : ''}>Claude 3.5 (Anthropic)</option>
          <option value="openai" ${keys.default_provider === 'openai' ? 'selected' : ''}>GPT-4o (OpenAI)</option>
          <option value="kimi" ${keys.default_provider === 'kimi' ? 'selected' : ''}>Kimi K2.6 (Moonshot)</option>
        </select>
      </div>

      <div class="settings-actions">
        <button class="btn btn-primary" id="save-keys">Save Keys</button>
        <button class="btn btn-secondary" id="clear-keys">Clear All Keys</button>
      </div>

      <div class="settings-note">
        <strong>Privacy:</strong> Keys are stored in your browser's localStorage. 
        They are only transmitted to the respective AI provider APIs when you send a chat message.
        No key is ever written to the harness database or server logs.
      </div>
    </div>
  `;

  container.appendChild(settingsEl);

  settingsEl.querySelector('#save-keys').addEventListener('click', () => {
    const newKeys = {
      anthropic_key: /** @type {HTMLInputElement} */ (settingsEl.querySelector('#key-anthropic')).value.trim(),
      openai_key: /** @type {HTMLInputElement} */ (settingsEl.querySelector('#key-openai')).value.trim(),
      kimi_key: /** @type {HTMLInputElement} */ (settingsEl.querySelector('#key-kimi')).value.trim(),
      github_token: /** @type {HTMLInputElement} */ (settingsEl.querySelector('#key-github')).value.trim(),
      default_provider: /** @type {HTMLSelectElement} */ (settingsEl.querySelector('#default-provider')).value,
    };
    saveKeys(newKeys);
    alert('Keys saved locally.');
  });

  settingsEl.querySelector('#clear-keys').addEventListener('click', () => {
    if (confirm('Clear all stored API keys?')) {
      localStorage.removeItem('harness_keys');
      /** @type {HTMLInputElement} */ (settingsEl.querySelector('#key-anthropic')).value = '';
      /** @type {HTMLInputElement} */ (settingsEl.querySelector('#key-openai')).value = '';
      /** @type {HTMLInputElement} */ (settingsEl.querySelector('#key-kimi')).value = '';
      /** @type {HTMLInputElement} */ (settingsEl.querySelector('#key-github')).value = '';
      alert('Keys cleared.');
    }
  });
}

/**
 * @returns {{ anthropic_key?: string; openai_key?: string; kimi_key?: string; github_token?: string; default_provider?: string }}
 */
export function loadKeys() {
  try {
    const raw = localStorage.getItem('harness_keys');
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

/**
 * @param {{ anthropic_key?: string; openai_key?: string; kimi_key?: string; github_token?: string; default_provider?: string }} keys
 */
function saveKeys(keys) {
  localStorage.setItem('harness_keys', JSON.stringify(keys));
}

/**
 * @param {string} str
 */
function escapeHtml(str) {
  if (!str) return '';
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
